<template>
    <div>
        <FormPicker :trigger="trigger" :formType="'contactform'" :title="'Choose post with contact form'" />
    </div>
</template>

<script>
import FormPicker from "./FormPicker.vue"

export default {
    components: { FormPicker },
    props: {
        trigger:  { type: Object, required: true }
    }
}
</script>
